import { create } from "zustand";

type taskStore = {
	selectedTask: any;
};

type taskActions = {
	updateSelectedTask: (data: any) => void;
	resetDataList: () => void;
	findDataMatchWithSelectedValue: (properties: any, hoaDatastore: any) => any;
	findDataMatchWithSelectedValueIndex: (properties: any, hoaDatastore: any) => any;
};

export const useSelectedTaskStoreStore = create<taskStore & taskActions>((set) => ({
	selectedTask: {},
	updateSelectedTask: (data: any) => {
		set({ selectedTask: data });
	},
	findDataMatchWithSelectedValue: (properties: any, hoaDatastore: any) => {
		const { selectedTask } = useSelectedTaskStoreStore.getState();
		return properties.find((prop: any) => {
			// Check basic conditions first
			const isMatchingId = prop.objectId === hoaDatastore.getIdFromUrl();
			const isMatchingSourceType = prop.taskSourceType === selectedTask.taskSourceType;

			if (!isMatchingId || !isMatchingSourceType) {
				return false;
			}

			// Check specific details based on task source type
			switch (selectedTask.taskSourceType) {
				case "mail":
					return (
						prop.mailDetails?.id === selectedTask.mailDetails?.id &&
						prop.mailDetails?.parsePropertyTaskId ===
							selectedTask.mailDetails?.parsePropertyTaskId
					);
				case "email":
					return (
						prop.emailDetails?.id === selectedTask.emailDetails?.id &&
						prop.emailDetails?.parsePropertyTaskId ===
							selectedTask.emailDetails?.parsePropertyTaskId
					);
				default:
					return false;
			}
		});
	},
	findDataMatchWithSelectedValueIndex: (properties: any, hoaDatastore: any) => {
		const { selectedTask } = useSelectedTaskStoreStore.getState();
		return properties.findIndex((prop: any) => {
			// Check basic conditions first
			const isMatchingId = prop.objectId === hoaDatastore.getIdFromUrl();
			const isMatchingSourceType = prop.taskSourceType === selectedTask.taskSourceType;

			if (!isMatchingId || !isMatchingSourceType) {
				return false;
			}

			// Check specific details based on task source type
			switch (selectedTask.taskSourceType) {
				case "mail":
					return (
						prop.mailDetails?.id === selectedTask.mailDetails?.id &&
						prop.mailDetails?.parsePropertyTaskId ===
							selectedTask.mailDetails?.parsePropertyTaskId
					);
				case "email":
					return (
						prop.emailDetails?.id === selectedTask.emailDetails?.id &&
						prop.emailDetails?.parsePropertyTaskId ===
							selectedTask.emailDetails?.parsePropertyTaskId
					);
				default:
					return false;
			}
		});
	},
	resetDataList: () => {
		set({ selectedTask: {} });
	},
}));
